__turbopack_context__.v({
  "floating-menu": "FloatingMenu-module-sass-module__iy6ghq__floating-menu",
  "floating-menu--active": "FloatingMenu-module-sass-module__iy6ghq__floating-menu--active",
  "floating-menu--light": "FloatingMenu-module-sass-module__iy6ghq__floating-menu--light",
  "floating-menu-item": "FloatingMenu-module-sass-module__iy6ghq__floating-menu-item",
  "floating-menu-item__name": "FloatingMenu-module-sass-module__iy6ghq__floating-menu-item__name",
  "floating-menu-item__name--absolute": "FloatingMenu-module-sass-module__iy6ghq__floating-menu-item__name--absolute",
  "floating-menu__items": "FloatingMenu-module-sass-module__iy6ghq__floating-menu__items",
});
